import React from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import TextLink from '@narvar/nth-text-link';
import { Container } from '@narvar/nth-grid';
import A11yDiv from '@narvar/nth-a11y-div';
import styled from 'styled-components';

const mapStateToProps = ({
  language,
  retailerSettings: { branding: { brand_call_to_action: brandCtaColor } = {} } = {},
}) => ({
  language,
  brandCtaColor,
});

const baseModalStyle = {
  overlay: {
    zIndex: '999',
    backgroundColor: 'rgb(0, 0, 0, 0.7)',
    animation: 'fadeIn 0.5s',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '800px',
    padding: '2rem',
    textAlign: 'center',
  },
};

const OpenLink = styled(TextLink)`
  text-decoration: underline;
`;

const ModalOpenLink = ({ toggleOpen, brandCtaColor, children }) => (
  <OpenLink
    target="_blank"
    s={{
      margin: '0',
      color: brandCtaColor,
      hoverColor: brandCtaColor,
      textDecoration: 'underline',
      hoverTextDecoration: 'underline',
    }}
    onClick={() => toggleOpen()}
    data-testid="modal-open-link"
  >
    {children}
  </OpenLink>
);

const XIcon = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  cursor: pointer;
  border: 0 none;
  background: transparent;
  :before,
  :after {
    content: '';
    background: ${({ brandCtaColor }) => brandCtaColor || '#000'};
    width: 2px;
    height: 20px;
    transform: rotate(45deg);
    display: block;
    position: absolute;
    top: 6px;
    left: 15px;
    border-radius: 5px;
    pointer-events: none;
  }
  :after {
    transform: rotate(135deg);
  }
`;

const ReturnsModal = ({
  brandCtaColor,
  toggleOpen,
  isOpen,
  children,
  openText,
  overlayStyle,
  contentStyle,
  staticBackdrop,
}) => (
  <A11yDiv onClick={(event) => event.stopPropagation()}>
    <ModalOpenLink {...{ toggleOpen, brandCtaColor }}>{openText}</ModalOpenLink>
    <Modal
      isOpen={isOpen}
      onRequestClose={staticBackdrop ? null : () => toggleOpen(false)}
      style={{
        overlay: { ...baseModalStyle.overlay, ...overlayStyle },
        content: { ...baseModalStyle.content, ...contentStyle },
      }}
      appElement={document.getElementById('main-returns-container') || document.body}
    >
      <XIcon
        onClick={() => toggleOpen(false)}
        brandCtaColor={brandCtaColor}
        data-testid="modal-close"
        className="modal-close"
      />
      <Container>{children}</Container>
    </Modal>
  </A11yDiv>
);

ModalOpenLink.defaultProps = {
  brandCtaColor: '#000000',
};

ModalOpenLink.propTypes = {
  toggleOpen: PropTypes.func.isRequired,
  brandCtaColor: PropTypes.string,
  children: PropTypes.node.isRequired,
};

ReturnsModal.defaultProps = {
  brandCtaColor: '#000000',
  overlayStyle: {},
  contentStyle: {},
  staticBackdrop: false,
};

ReturnsModal.propTypes = {
  language: PropTypes.object.isRequired,
  brandCtaColor: PropTypes.string,
  toggleOpen: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  openText: PropTypes.string.isRequired,
  overlayStyle: PropTypes.object,
  contentStyle: PropTypes.object,
  staticBackdrop: PropTypes.bool,
};

export default connect(mapStateToProps)(ReturnsModal);
